import type { FC } from 'react';

import { NAVIGATION, filterNavigation } from '../../data/navigation';
import type { AuthUser, Organization } from '../../types/user';
import { userInitials, userName } from '../../types/user';
import { BrandMarkIcon } from '../../assets/icons/icons';
import { NavGroup } from './NavGroup';
import styles from './Sidebar.module.scss';
import React, { useMemo } from 'react';
import { useIsAdmin } from '../../hooks/useIsAdmin';
import { useAppDispatch } from '../../app/hooks';
import { openOrganizationSwitcher } from '../../entities/organization/model/slice';
import { Tooltip } from '../ui/Tooltip/Tooltip';

interface SidebarProps {
    user?: AuthUser | null;
    organization?: Organization | null;
}

export const Sidebar: FC<SidebarProps> = ({ user, organization }) => {
    const admin = useIsAdmin();
    const dispatch = useAppDispatch();
    const items = useMemo(() => filterNavigation(NAVIGATION, admin), [admin]);

    return (
        <aside className={styles.sidebar}>
            <div className={styles.brand}>
                <BrandMarkIcon className={styles.mark} aria-label="Логотип сервиса" />

                <div>
                    <b className={styles.brandName}>
                        Предиктивная
                        <br />
                        аналитика
                    </b>
                    <small className={styles.brandRegion}>Ямало-Ненецкий АО</small>
                </div>
            </div>

            <div className={styles.scroll}>
                <div className={styles.navTitle}>Навигация</div>

                <nav className={styles.nav}>
                    {items.map((node) => (
                        <NavGroup key={node.id} node={node} />
                    ))}
                </nav>
            </div>

            <div className={styles.bottom}>
                {organization && (
                    <Tooltip text="Сменить организацию" align="right">
                        <button
                            type="button"
                            className={styles.org}
                            onClick={() => dispatch(openOrganizationSwitcher())}
                        >
                            <span>Организация</span>
                            <b>{organization.name ?? organization.full_name}</b>
                        </button>
                    </Tooltip>
                )}

                <div className={styles.profile}>
                    <div className={styles.avatar}>{userInitials(user)}</div>

                    <div>
                        <b>{userName(user)}</b>
                        {/* <small>Профиль</small> */}
                    </div>
                </div>
            </div>
        </aside>
    )
};